<widget-pannel
		[storageName]="'aurora_widgetAcces_hideContent'"
		[iconClass]="'fa fa-key fa-fw'"
		[title]="'Acc&egrave;s en cours'"
		[alt]="'Acc&egrave;s en cours'"
		[href]="gestionAccesUrl()"
		>
	<antenne-checkbox-list *ngIf="isUserSuperviseur"
			[id]="'choixAntennes'"
			[label]="null"
			[fieldClass]="'form-group text-center'"
			(selectionIdsChange)="onSelectedAntenneIdsChange($event)"
		>
	</antenne-checkbox-list>
	<div class="mat-elevation-z8">
		<table mat-table [dataSource]="dataSource" style="width: 100%">
			<ng-container matColumnDef="numero">
				<th mat-header-cell *matHeaderCellDef> Num&eacute;ro </th>
				<td mat-cell *matCellDef="let row"> {{ row.acces.numero }}</td>
			</ng-container>
		
			<ng-container matColumnDef="antenne">
				<th mat-header-cell *matHeaderCellDef> Antenne </th>
				<td mat-cell *matCellDef="let row"> {{ row.antenne.nom }}</td>
			</ng-container>
		
			<ng-container matColumnDef="parc">
				<th mat-header-cell *matHeaderCellDef> Parc </th>
				<td mat-cell *matCellDef="let row">
					<i class="fa {{ row.parcIcon }}" title="{{ row.parc.energie }}"></i> {{ row.parc.code }}
				</td>
			</ng-container>
		
			<ng-container matColumnDef="ouvrages">
				<th mat-header-cell *matHeaderCellDef> Ouvrage(s) </th>
				<td mat-cell *matCellDef="let row"> {{ row.nomsOuvrages }} </td>
			</ng-container>
		
 			<ng-container matColumnDef="cac">
				<th mat-header-cell *matHeaderCellDef> Valideur </th>
				<td mat-cell *matCellDef="let row"> {{ row.cac ? row.cac.lastName : '' }} </td>
			</ng-container>
		
			<ng-container matColumnDef="entreprise">
				<th mat-header-cell *matHeaderCellDef> Entreprise </th>
				<td mat-cell *matCellDef="let row">  {{ row.entreprise }} </td>
			</ng-container>
		
			<ng-container matColumnDef="ca">
				<th mat-header-cell *matHeaderCellDef> CA </th>
				<td mat-cell *matCellDef="let row">  {{ row.ca }} </td>
			</ng-container>
		
			<ng-container matColumnDef="debut">
				<th mat-header-cell *matHeaderCellDef> D&eacute;but </th>
				<td mat-cell *matCellDef="let row"> {{ row.acces.dateDebut  | localDateTimeToDate: row.acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>
		
			<ng-container matColumnDef="autorisation">
				<th mat-header-cell *matHeaderCellDef> Date Autorisation </th>
				<td mat-cell *matCellDef="let row"> {{ row.acces.dateAutorisation  | localDateTimeToDate: row.acces.ice | date : 'dd/MM/yyyy HH:mm' }}</td>
			</ng-container>

 			<ng-container matColumnDef="controleSecurite">
				<th mat-header-cell *matHeaderCellDef> Contr&ocirc;le s&eacute;curit&eacute; </th>
				<td mat-cell *matCellDef="let row">  {{ controlesSecurite.get(row.acces.controleSecurite) }} </td>
			</ng-container>
		
			<ng-container matColumnDef="numCrCarl">
				<th mat-header-cell *matHeaderCellDef> N&deg; CR CARL </th>
				<td mat-cell *matCellDef="let row">
					<span *ngFor="let refCarl of row.refsCarl">{{ refCarl }}<br/></span>
				</td>
			</ng-container>
		
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked(row)"></tr>
		</table>
		<mat-paginator #paginator
			showFirstLastButtons
			[pageSizeOptions]="[5, 10, 20, 50]"
			[pageSize]="20"
			aria-label="Choisissez une page">
		</mat-paginator>
	</div>		
</widget-pannel>